export const flexAmount = 'flex-amount';
export const flexDate = 'flex-date';
